import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Nav from "./incomeTaxNav";
import ClientIncomeTaxProvider from "./ClientIncomeTaxContext";

const ClientIncomeTaxView = () => {
    return (
        <ClientIncomeTaxProvider>
            <Box>
                <Nav />
                <Outlet /> {/* This will load the child components */}
            </Box>
        </ClientIncomeTaxProvider>
    );
};

export default ClientIncomeTaxView;
